import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/tmp/8dee27db936352c/src/modules/core/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/tmp/8dee27db936352c/src/modules/core/providers/SessionProvider.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee27db936352c/src/modules/shared/providers/DialogProvider/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee27db936352c/src/styles/application.scss");
